import { BaseCredentialApplicationReportFields } from './base-credential-application-report.fields';

export const TeamCredentialApplicationReportFields = {
  ...BaseCredentialApplicationReportFields,
  teamName: 'name',
  teamPublicName: 'publicName',
  workspaceName: 'workspaceName',
  scenarios: 'scenarios'
} as const;

export type TeamCredentialApplicationReportFields =
  (typeof TeamCredentialApplicationReportFields)[keyof typeof TeamCredentialApplicationReportFields];
